import styled from "styled-components";
import Icon from "../../../../../base/icons/icon/index.js";
import Image from "../../../../../base/multimedia/image/index.js";
import { InnerMarkdownHTML } from "../../../../../base/text/inner-markdown-HTML/index.js";
import Modal from "../../../../../structures/others/modal/index.js";
import { ModalWrapper } from "../../../../../structures/others/modal/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { Margin } from "../../../../../../styles/common/mixins/logical.styled.js";
import { Stars } from "../../../../../../styles/common/mixins/stars.styled.js";
import productCardMobileThemes from "./themes/index.js";
export const ProductCardBox = styled.article.withConfig({
    displayName: "styled__ProductCardBox",
    componentId: "sc-a7fc2756-0"
})`
	border-top: 1px solid ${({ theme  })=>theme.colors.grays.light};
	border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
	background: ${({ theme  })=>theme.colors.white.base};
	position: relative;

	&.is-sold-out {
		overflow: hidden;

		&::before {
			background-color: ${({ theme  })=>theme.colors.black.lower};
			content: '';
			height: 100%;
			left: 0;
			position: absolute;
			top: 0;
			width: 100%;
			z-index: ${({ theme  })=>theme.zIndex.low};
		}

		&::after {
			${FontMixin({
    size: 'xl',
    weight: 'semiBold',
    height: 'xl'
})}
			background: ${({ theme  })=>theme.colors.black.base};
			border: 4px solid ${({ theme  })=>theme.colors.secondary.base};
			color: ${({ theme  })=>theme.colors.white.base};
			content: 'sold out!';
			font-family: ${({ theme  })=>theme.font.family.secondary};
			left: 50%;
			padding: 16px 28px;
			position: absolute;
			text-align: center;
			text-transform: uppercase;
			top: 50%;
			transform: rotate(-10deg) translate(-50%, -100%);
			width: 120%;
			z-index: ${({ theme  })=>theme.zIndex.base};
		}
	}
`;
export const ProductCardLink = styled.a.withConfig({
    displayName: "styled__ProductCardLink",
    componentId: "sc-a7fc2756-1"
})`
	${FlexMixin({
    direction: 'row'
})}
`;
export const ProductCardImageContainer = styled.div.withConfig({
    displayName: "styled__ProductCardImageContainer",
    componentId: "sc-a7fc2756-2"
})`
	overflow: hidden;
	min-width: 112px;
	${FlexMixin({
    direction: 'column',
    justify: 'space-between'
})}

	& .itinerary {
		position: relative;
		height: 100%;
		width: 100%;
		max-width: 112px;
		overflow: hidden;

		& img {
			object-fit: cover;
			position: absolute;
			top: 0;
			height: 100%;
			left: 50%;
			transform: translateX(-50%);
			max-width: initial;
			aspect-ratio: 16 / 9;
			width: 100%;
			object-fit: cover;
		}
	}

	& .logo {
		margin: 4px 0;
		background: ${({ theme  })=>theme.colors.white.base};
		position: relative;
		bottom: 0;

		& img {
			height: auto;
			width: 100%;
		}
	}
`;
export const ProductCardHeader = styled.div.withConfig({
    displayName: "styled__ProductCardHeader",
    componentId: "sc-a7fc2756-3"
})`
	${FontMixin({
    height: 'base'
})};

	& > *:last-child {
		margin-bottom: 8px;
	}
`;
export const ProductCardContent = styled.div.withConfig({
    displayName: "styled__ProductCardContent",
    componentId: "sc-a7fc2756-4"
})`
	padding: 8px 12px;
	${FlexMixin({
    justify: 'space-between',
    direction: 'column'
})}
	flex-grow: 1;
	min-height: 120px;
`;
export const ProductCardTitle = styled.h3.withConfig({
    displayName: "styled__ProductCardTitle",
    componentId: "sc-a7fc2756-5"
})`
	${FontMixin({
    size: 'base',
    height: 'base',
    weight: 'regular'
})};
	color: ${({ theme  })=>theme.colors.grays.darker};

	${({ theme  })=>productCardMobileThemes[theme.id]?.ProductCardTitle?.()}
`;
export const Subtitle = styled.p.withConfig({
    displayName: "styled__Subtitle",
    componentId: "sc-a7fc2756-6"
})`
	& > .product-card-subtitle {
		${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'light'
})};
		color: ${({ theme  })=>theme.colors.grays.dark};
		margin-right: 4px;
	}
	& > .product-card-textInfo {
		${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'medium'
})};
		color: ${({ theme  })=>theme.colors.grays.darker};
		margin-right: 4px;
		display: block;
	}

	${Stars} {
		${FontMixin({
    size: 'small',
    height: 'smaller',
    weight: 'regular'
})};
		& > i {
			margin-left: 2px;
		}
	}
`;
export const Detail = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__Detail",
    componentId: "sc-a7fc2756-7"
})`
	${FontMixin({
    size: 'base',
    height: 'base',
    weight: 'light'
})};
	color: ${({ theme  })=>theme.colors.grays.dark};
	margin-bottom: 8px;
`;
export const Descriptions = styled.div.withConfig({
    displayName: "styled__Descriptions",
    componentId: "sc-a7fc2756-8"
})`
	color: ${({ theme  })=>theme.colors.grays.dark};
	${FontMixin({
    size: 'small',
    height: 'medium',
    weight: 'light'
})};
	overflow: hidden;
	&.is-deal {
		margin-right: 14px;
	}
`;
export const ProductCardPrice = styled.div.withConfig({
    displayName: "styled__ProductCardPrice",
    componentId: "sc-a7fc2756-9"
})`
	${FontMixin({
    size: 'larger',
    height: 'large',
    weight: 'medium'
})}
	color: ${({ theme  })=>theme.colors.secondary.base};

	margin-left: 12px;
	max-width: 45%;
	text-align: end;

	flex-shrink: 0;
	align-self: flex-end;
	align-items: flex-end;
	${FlexMixin({
    direction: 'column',
    align: 'flex-end'
})}

	.from {
		${FontMixin({
    size: 'smaller',
    height: 'small',
    weight: 'regular'
})}
	}

	.old-price {
		${FontMixin({
    size: 'medium',
    height: 'small',
    weight: 'regular'
})};
		text-decoration: line-through;
	}
`;
export const Upside = styled.div.withConfig({
    displayName: "styled__Upside",
    componentId: "sc-a7fc2756-10"
})`
	color: ${({ theme  })=>theme.colors.primary.lighter};
	${FontMixin({
    size: 'small',
    weight: 'medium',
    height: 'medium'
})}
`;
export const Promotion = styled.div.withConfig({
    displayName: "styled__Promotion",
    componentId: "sc-a7fc2756-11"
})`
	color: ${({ theme  })=>theme.colors.status.offer};
	${FontMixin({
    size: 'small',
    weight: 'medium',
    height: 'medium'
})}
`;
export const Tripadvisor = styled(Image).withConfig({
    displayName: "styled__Tripadvisor",
    componentId: "sc-a7fc2756-12"
})`
	width: 120px;
	height: 20px;
	margin-left: -8px;
`;
export const Reviews = styled.div.withConfig({
    displayName: "styled__Reviews",
    componentId: "sc-a7fc2756-13"
})`
	color: ${({ theme  })=>theme.colors.status.success};
	${FontMixin({
    size: 'small',
    weight: 'medium',
    height: 'medium'
})}
	${FlexMixin({
    align: 'center'
})}

  ${Icon} {
		margin: 0 4px 4px 4px;
	}

	&.reviews-veryGood {
		color: ${({ theme  })=>theme.colors.primary.lighter};
	}
`;
export const Transport = styled.div.withConfig({
    displayName: "styled__Transport",
    componentId: "sc-a7fc2756-14"
})`
	color: ${({ theme  })=>theme.colors.status.success};
	${FontMixin({
    size: 'small',
    weight: 'medium',
    height: 'medium'
})}
`;
export const ProductCardFooter = styled.div.withConfig({
    displayName: "styled__ProductCardFooter",
    componentId: "sc-a7fc2756-15"
})`
	${FlexMixin({
    justify: 'space-between'
})}
`;
export const ProductCardDescription = styled.div.withConfig({
    displayName: "styled__ProductCardDescription",
    componentId: "sc-a7fc2756-16"
})`
	${FlexMixin({
    direction: 'column',
    justify: 'flex-end'
})}
	${FontMixin({
    height: 'medium'
})}
	overflow: hidden;
`;
export const ProductCardIconProps = styled.div.withConfig({
    displayName: "styled__ProductCardIconProps",
    componentId: "sc-a7fc2756-17"
})`
	color: ${({ theme  })=>theme.colors.primary.lighter};

	${FontMixin({
    size: 'large',
    height: 'base',
    weight: 'regular'
})}

	${FlexMixin({
    align: 'center'
})}
	margin-right: 4px;
	margin-top: 4px;

	${Icon} {
		width: 30px;
		height: 30px;
		${FlexMixin({
    align: 'center'
})}
	}
`;
export const SearcherModal = styled(Modal).withConfig({
    displayName: "styled__SearcherModal",
    componentId: "sc-a7fc2756-18"
})`
	${ModalWrapper} {
		background-color: ${(props)=>props.theme.colors.primary.base};
	}
`;
export const Title = styled.div.withConfig({
    displayName: "styled__Title",
    componentId: "sc-a7fc2756-19"
})`
	color: ${(props)=>props.theme.colors.white.base};
	${Margin({
    all: '0px'
})}
	${FontMixin({
    size: 'largest',
    weight: 'medium',
    height: 'largest'
})}
	text-align: center;
`;

//# sourceMappingURL=styled.js.map